import React from 'react'
import { useIntl } from 'react-intl'
import { toast } from 'react-toastify'
import { LinearProgress } from '@mui/material'
import { H3 } from '../../../layouts/TextStyles'
import { promocodeApi } from '../../../features/promocode/promocode'
import AddPromocodeDialog from './components/AddPromocodeDialog'
import PromocodeTable from './components/PromocodeTable'
import Sentinel from '../../../components/infiniteScroll/Sentinel'
import { usePaginatedList } from '../../../app/hooks/usePaginatedList'
import { Content, Header, Title, Wrapper } from './style'

const PromocodeListPage = () => {
    const { formatMessage } = useIntl()
    const [fetchPromocodes] = promocodeApi.useLazyFetchAllGeneralPromocodeQuery()
    const [deleteGeneralPromocode, { isLoading: isDeleting }] =
        promocodeApi.useDeleteGeneralPromocodeMutation()

    const { rows, isLoading, loadedPages, sentinelRef, reload } =
        usePaginatedList(
            (page, size) => fetchPromocodes({ page, size }).unwrap(),
            [],
        )

    const handleDelete = async (id: number) => {
        try {
            await deleteGeneralPromocode(id).unwrap()
            toast.success(formatMessage({ id: 'deletedSuccess' }))
            reload()
        } catch (e) { }
    }

    return (
        <Wrapper>
            <Content>
                <Header>
                    <Title>
                        <H3> {formatMessage({ id: 'promocode' })} </H3>
                    </Title>
                    <AddPromocodeDialog />
                </Header>

                {(isLoading && loadedPages === 0) || isDeleting ? (
                    <LinearProgress />
                ) : (
                    <>
                        <PromocodeTable
                            isFetching={isLoading}
                            promocodeData={rows}
                            onDelete={handleDelete}
                        />

                        <Sentinel ref={sentinelRef} isLoading={isLoading} />
                    </>
                )}
            </Content>
        </Wrapper>
    )
}

export default PromocodeListPage
